var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShelvesFill1Wght700Grad200Opsz48(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 -960 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157.825-40q-19.45 0-32.637-13.325Q112-66.65 112-86v-789q0-18.375 13.358-31.688Q138.716-920 158.158-920q18.442 0 32.142 13.312Q204-893.375 204-875v27h554v-27q0-18.375 13.358-31.688Q784.716-920 803.158-920t32.642 13.312Q850-893.375 850-875v789q0 19.35-14.15 32.675Q821.699-40 802.825-40q-18.45 0-31.637-13.325Q758-66.65 758-86v-28H204v28q0 19.35-13.65 32.675Q176.699-40 157.825-40ZM204-510h82v-114q0-20.2 13.312-33.1Q312.625-670 331-670h146q18.8 0 32.4 12.9Q523-644.2 523-624v114h235v-246H204v246Zm0 320h235v-114q0-20.2 13.312-33.1Q465.625-350 484-350h146q18.8 0 32.4 12.9Q676-324.2 676-304v114h82v-244H204v244Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShelvesFill1Wght700Grad200Opsz48);
export default __webpack_public_path__ + "static/media/shelves_FILL1_wght700_GRAD200_opsz48.19a0711c2c1bfd3eebf0eb4a1eb60041.svg";
export { ForwardRef as ReactComponent };